<div class="step-card-wrapper" *ngIf="card">
  <div
    class="step-card"
    [class.step-card--queued]="card.status === ApprovalStatusEnum.ON_QUEUED"
    [class.step-card--cancelled]="card.status === ApprovalStatusEnum.CANCELLED"
    [class.step-card--approved]="card.status === ApprovalStatusEnum.APPROVED"
    [class.step-card--rejected]="card.status === ApprovalStatusEnum.REJECTED"
    [class.step-card--awaiting]="card.status === ApprovalStatusEnum.AWAITING"
  >
    <div
      class="step-card-accent"
      [ngClass]="'accent-' + (card.status ? card.status.toLowerCase() : 'on_queued')"
    ></div>
    <div class="step-card-body">
      <div class="step-header-row">
        <div class="step-name">{{ card.stepName }}</div>
        <div class="step-tag" *ngIf="card.supervisorLevel">{{ card.supervisorLevel }}</div>
      </div>

      <div class="step-divider"></div>

      <div class="step-status-row">
        <span class="step-status-text">{{ statusText }}</span>
        <span *ngIf="card.actionedAt && isApprovedOrRejected" class="step-timestamp">
          {{ card.actionedAt | amFromUtc | amLocal | dateDisplay: 'DD/MM/YYYY HH:mm' : '-' }}
        </span>
      </div>

      <div class="step-divider"></div>

      @if (card.autoApprove) {
        <div class="approver-header">Auto Approve:</div>
        <div class="approver-header">{{ card.autoApprovalLimit | numberFormatDisplay: 2 }}</div>
      } @else {
        <div class="approver-header">Approver:</div>
        <div class="approver-list">
          @for (approver of card.approvers; track approver.userNo || $index) {
            <div
              class="approver-item"
              [class.active]="isApproverActive(approver)"
              [class.muted]="!isApproverActive(approver)"
              [class.approved]="approver.approve === true"
              [class.rejected]="approver.approve === false"
            >
              <em *ngIf="approver.approve === true" class="icon-approved-workflow mr-1"></em>
              <em *ngIf="approver.approve === false" class="icon-rejected-workflow mr-1"></em>
              <span class="approver-name">{{ approverName(approver) }}</span>
            </div>
          }
        </div>
      }
    </div>
  </div>

  @if (card.comment && isApprovedOrRejected) {
    <div class="step-comment-card">
      <div class="comment-header">Comment</div>
      <div class="comment-body" [innerHTML]="card.comment"></div>
    </div>
  }
</div>
